<template>
  <button
    class="button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <component
      v-if="iconSvg"
      v-bind:is="svgComponent"
    />

    <slot v-else />
  </button>
</template>

<script>
export default {
  props: {
    iconSvg: { type: String, default: null },
  },

  computed: {
    svgComponent() {
      return require(`@/components/svg/${this.iconSvg}.vue`).default
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff8000;
    border-radius: 8px;
    padding: 8px;

    ::v-deep svg {
      fill: #fff;
    }
    
    &.size--small {
      width: 32px;
      height: 32px;
    }
  }
</style>